export const Status = {
  DONE: 'Done',
  DEPRECATED: 'Deprecated',
  IN_PROGRESS: 'In Progress',
  CLEANED: 'Cleaned',
  ERRORED: 'Errored',
  NOT_STARTED: 'Not started'
};
